<template>
  <div>
    <h1 class="onboarding__title mb-5">
      {{ $t('onboarding.contract.title') }}
    </h1>

    <div class="mh-450 scrollable body-2 pr-5">
      <v-card v-if="isLoading" class="rounded-0 pa-5" flat>
        <v-progress-linear indeterminate />
      </v-card>

      <div v-else v-html="onboardingContract" />
    </div>

    <v-divider class="mb-5" />

    <v-row>
      <v-col>
        <v-btn @click="setOnboardingStepsNavigation(4)" elevation="0" large>
          <v-icon left small> mdi-chevron-left </v-icon>
          {{ $t('onboarding.actions.previous') }}
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          @click="acceptAndGoToPayment"
          :loading="onboardingLoading"
          color="primary"
          elevation="0"
          large
        >
          {{ $t('onboarding.contract.acceptAndGoToPayment') }}
          <v-icon right small> mdi-chevron-right </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsContract',

  data() {
    return {
      acceptContract: false,
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'onboardingLoading',
      'onboardingContract',
      'onboardingStepsNavigation',
    ]),
  },

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),
    ...mapActions(['onboardingRequestContract', 'onboardingAcceptContract']),

    acceptAndGoToPayment() {
      this.onboardingAcceptContract()
    },
  },

  watch: {
    onboardingStepsNavigation(step) {
      step === 5 && this.onboardingRequestContract('CONTRACT')
    },
  },
}
</script>
